import Vue from 'vue';
import LoaderComponent from './components/Loader';

Vue.config.devtools = true;
Vue.config.productionTip = false;

let component = document.getElementById('js-loader');

class Loader {
  init() {
    this.startApp();
  }

  startApp() {
    new Vue({
      el: component,
      render: h => h(LoaderComponent),
    });
  }
}

export const loader = new Loader();



// WEBPACK FOOTER //
// ./src/global/loader/Loader.js